'use client';

import { notFound, usePathname } from 'next/navigation';
import Popup from '@/features/popup';
import { extractHomeComponents } from '@/app/(home-page)/_utils/extract-home-components';
import { useHomePageData } from '@/app/(home-page)/_utils/use-home-page-data';
import { TimeoutError as TimeoutErrorClass } from '@/app/_utils/types';
import { GIFT_CARD_LANDING_PATH } from './contants';
import TimeoutError from './timeout-error';
import FAQContent from './faq-for-gift-landing/faq-content';
interface Props {
  slug?: string;
  isLandingCategory?: boolean;
}
function HomeContent({
  slug,
  isLandingCategory = false
}: Props) {
  const pathname = usePathname();
  const {
    data: homeProperties,
    isLoading,
    error,
    refetch
  } = useHomePageData(slug);
  const extractedComponents = extractHomeComponents(homeProperties?.components, slug);
  const isTimeoutError = error instanceof TimeoutErrorClass;
  if (isTimeoutError) {
    return <TimeoutError refetch={refetch} />;
  }
  if (!isLoading && !homeProperties) notFound();
  if (!extractedComponents) return null;
  const isLandingPage = !!slug;
  const showH1 = isLandingPage && !isLandingCategory;
  return <>
            {!isLandingPage && <Popup isHomePage />}
            {showH1 && <h1 className='hidden'>{homeProperties?.title}</h1>}
            <div className='relative z-10 flex w-full flex-col gap-6 pb-10 pt-4 lg:gap-8 lg:pb-12 lg:pt-10'>
                {extractedComponents?.map(item => item)}
                {pathname === GIFT_CARD_LANDING_PATH && <FAQContent />}
            </div>
        </>;
}
export default HomeContent;